(function(){
  if(window.__bblShip)return;window.__bblShip=1;
  function fmt(ms){var m=Math.floor(ms/60000),d=Math.floor(m/1440),h=Math.floor((m%1440)/60),mm=m%60;return d+'d '+h+'h '+mm+'m';}
  function money(c){return '$'+(c/100).toFixed(2);}
  function tick(){
    var now=Date.now();
    document.querySelectorAll('[data-bbl-ship]').forEach(function(el){
      var end=+el.dataset.promoEnd*1000, start=+el.dataset.barStart*1000;
      var promo=el.querySelector('[data-bbl-promo]'), cd=el.querySelector('[data-bbl-countdown]'), t=el.querySelector('[data-bbl-time]');
      var live=now<end;
      if(promo) promo.hidden=!live;
      if(cd&&t){ if(live){t.textContent=fmt(end-now);cd.hidden=false;} else cd.hidden=true; }
      var bar=el.querySelector('[data-bbl-bar]'); if(bar) bar.hidden=now<start;
      var std=el.querySelector('[data-bbl-std]'); if(std) std.hidden=now<start;
    });
  }
  function refreshBar(){
    if(Date.now()<1793509200000) return;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-bbl-ship]').forEach(function(el){
        var txt=el.querySelector('[data-bbl-bar-text]'),fill=el.querySelector('[data-bbl-fill]');if(!txt)return;
        var th=+el.dataset.threshold,rem=th-c.total_price;
        txt.innerHTML=rem>0?"You're <strong>"+money(rem)+"</strong> away from free shipping":"<strong>You've unlocked free US shipping</strong>";
        if(fill) fill.style.width=Math.min(100,c.total_price*100/th)+'%';
      });
    }).catch(function(){});
  }
  function init(){tick();refreshBar();setInterval(tick,30000);
    ['cart-items','cart-drawer-items','cart-drawer'].forEach(function(s){var n=document.querySelector(s);if(n)new MutationObserver(function(){clearTimeout(window.__bblT);window.__bblT=setTimeout(function(){tick();refreshBar();},250);}).observe(n,{childList:true,subtree:true});});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
